import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../../../../components/Breadcrum";
import { ArrowRight } from "lucide-react";
import "./Seeds.css";

export default function Seeds() {
    const seedsProducts = [
        {
            id: 1,
            name: "PUMPKIN SEEDS",
            image: "/assets/img/Seeds/Pumpkin-Seeds.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Snack products",
                        "Breakfast cereals",
                        "Bakery items",
                        "Trail mixes",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Rich in protein",
                        "High mineral content",
                        "Crunchy texture",
                        "Healthy snack option",
                    ],
                },
            ],
        },

        {
            id: 2,
            name: "SUNFLOWER SEEDS",
            image: "/assets/img/Seeds/Sunflower-Seeds.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Snack foods",
                        "Bakery products",
                        "Granola mixes",
                        "Food processing",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Rich in Vitamin E",
                        "Healthy fats",
                        "Versatile ingredient",
                        "Popular snack choice",
                    ],
                },
            ],
        },

        {
            id: 3,
            name: "WATERMELON SEEDS",
            image: "/assets/img/Seeds/Watermelon-Seeds.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Snack mixes",
                        "Dry fruit blends",
                        "Traditional sweets",
                        "Healthy foods",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "High protein content",
                        "Rich in minerals",
                        "Crunchy texture",
                        "Healthy snack option",
                    ],
                },
            ],
        },

        {
            id: 4,
            name: "CHIA SEEDS",
            image: "/assets/img/Seeds/Chia-Seeds.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Smoothies",
                        "Health drinks",
                        "Breakfast bowls",
                        "Nutritional supplements",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "High Omega-3 content",
                        "Rich fiber source",
                        "Superfood ingredient",
                        "Supports healthy diet",
                    ],
                },
            ],
        },

        {
            id: 5,
            name: "FLAX SEEDS",
            image: "/assets/img/Seeds/Flax-Seeds.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Bakery products",
                        "Health foods",
                        "Smoothies",
                        "Diet supplements",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Rich in Omega-3",
                        "High fiber content",
                        "Supports digestion",
                        "Widely used superfood",
                    ],
                },
            ],
        },

        {
            id: 6,
            name: "SESAME SEEDS",
            image: "/assets/img/Seeds/Sesame-Seeds.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Bakery products",
                        "Traditional sweets",
                        "Seasoning",
                        "Tahini production",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Rich nutty flavor",
                        "High calcium content",
                        "Versatile ingredient",
                        "Widely used globally",
                    ],
                },
            ],
        },
    ];

    const defaultImage =
        "https://upload.wikimedia.org/wikipedia/commons/7/79/Polypropylene_%28PP%29_Granules.jpg";

    const [selectedProduct, setSelectedProduct] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Breadcrumb
                title="Seeds"
                backgroundImage="./assets/img/contact-banner.png"
                height="40vh"
            />

            <section className="pp-section">
                <div className="container">
                    <h1 className="pp-title">Seeds Product Range</h1>

                    <p className="pp-subtitle">
                        Explore our premium range of healthy seeds sourced from trusted suppliers worldwide.
                    </p>

                    <div className="pp-grid">
                        {seedsProducts.map((product) => (
                            <div className="pp-card" key={product.id}>
                                <div className="pp-img-box">
                                    <img
                                        src={product.image || defaultImage}
                                        alt={product.name}
                                        onError={(e) => (e.target.src = defaultImage)}
                                    />
                                </div>

                                <div className="pp-info">
                                    <h2 className="pp-name">{product.name}</h2>

                                    <button
                                        className="view-btn"
                                        onClick={() => setSelectedProduct(product)}
                                    >
                                        View Details <ArrowRight size={16} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {selectedProduct && (
                        <div
                            className="modal-overlay"
                            onClick={() => setSelectedProduct(null)}
                        >
                            <div
                                className="modal-content"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <img
                                    src={selectedProduct.image || defaultImage}
                                    alt={selectedProduct.name}
                                    className="modal-image"
                                />

                                <h2 className="modal-title">{selectedProduct.name}</h2>

                                <div className="usage-section">
                                    {selectedProduct.usage.map((section, index) => (
                                        <div key={index} className="usage-block">
                                            <h3>{section.title}</h3>
                                            <ul>
                                                {section.points.map((point, i) => (
                                                    <li key={i}>{point}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>

                                <button
                                    className="close-btn"
                                    onClick={() => setSelectedProduct(null)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </>
    );
}